/* eslint-disable */
import {
  getTaxiCars
} from '@/requests/carPark'
import Api from '@/repository/index'
import { showDefaultErrorMessage } from '@/utils/createMessage'
import { Message } from 'element-ui'
const state = {
  carParkData: [],
  isLoading: true,
  filters: {
    brand: '',
    model: '',
    number: '',
    isValidate: true,
    status: 'working',
    year: '',
    callsign: '',
    offset: 0,
    limit: 50
  },
  carsModels: {},
  total_count: 0,
  currentRegionParkID: null
}

const mutations = {
  SET_CARS: (state, carData) => {
    state.carParkData = carData
  },
  SET_TOTAL: (state, data) => {
    state.total_count = data
  },
  SET_CARS_MODELS: (state, data) => {
    state.carsModels = data
  },
  SET_FILTERS: (state, filters) => {
    state.filters = {
      ...state.filters,
      ...filters
    }
  },
  TOOGLE_LOADING (state, value) {
    state.isLoading = value
  },
  UPDATE_CAR_BY_ID: (state, { data, id }) => {
    const carIndex = state.carParkData.findIndex(d => d.carId === data.carId)
    state.carParkData[carIndex] = {
      ...state.carParkData[carIndex],
      ...data
    }
  },
  SET_CURRENT_REGION_PARK_ID: (state, value) => {
    state.currentRegionParkID = value
  }

}

const actions = {
  setFilters ({ commit, state }, SomeFilters) {
    commit('SET_FILTERS', SomeFilters)
  },
  setCurrentRegionParkID ({ commit }, region_park_id) {
    commit('SET_CURRENT_REGION_PARK_ID', region_park_id)
  },
  fetchCarPark ({ commit, state }) {
    commit('TOOGLE_LOADING', true)
    return getTaxiCars({ regionParkId: state.currentRegionParkID })
      .then(carParkData => {
        commit('SET_CARS', carParkData)
        commit('TOOGLE_LOADING', false)
        return carParkData
      })
      .catch((error) => {
        commit('TOOGLE_LOADING', false)
        return Promise.reject(error)
      })
  },
  async fetchCarParkCommon ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING', true)

      const response = await Api.parkManager.cars.getCars({ regionParkId: state.currentRegionParkID, ...state.filters })
      commit('SET_CARS', response.cars)
      commit('SET_TOTAL', response.total)
      commit('TOOGLE_LOADING', false)
      return response
    } catch (err) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(err)
    }
  },
  async getCarModels ({ commit, state }) {
    try {
      const response = await Api.parkManager.cars.getCarModels()
      commit('SET_CARS_MODELS', response.carModels)
      return response
    } catch (err) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(err)
    }
  },
  async fetchCarParkShort ({ commit, state }) {
    try {
      commit('TOOGLE_LOADING', true)
      const response = await Api.parkManager.cars.getCarsShort({ regionParkId: state.currentRegionParkID })
      commit('SET_CARS', response)
      commit('TOOGLE_LOADING', false)
      return response
    } catch (err) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(err)
    }
  },
  async getCarById ({ commit }, id) {
    try {
      const response = await Api.parkManager.cars.getCarById(id)
      return response
    } catch (err) {
      return Promise.reject(err)
    }
  },
  async putTaxiCar ({ commit }, { data, id }) {
    try {
      const response = await Api.parkManager.cars.updateCarSettings({ ...data })
      commit('UPDATE_CAR_BY_ID', { data: response })
    } catch (err) {
      return Promise.reject(err)
    }
  },
  async generateCarParkFromYandexData () {
    try {
      const response = await Api.parkManager.cars.saveTaxiCarsFromYandex()
      const { success } = response
      if (!success) return showDefaultErrorMessage()
      return Message({
        message: 'Машины успешно сохранены!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (e) {
      return Promise.reject(e)
    }
  }
}

const getters = {
  GET_ONLY_BRANDS: (state) => {
    const onlyBrands = state.carParkData.map(a => a.brand)
    return [...new Set(onlyBrands)]
  },
  GET_ONLY_MODELS: (state) => {
    const onlyModels = state.carParkData.map(a => a.model)
    return [...new Set(onlyModels)]
  },
  GET_OBLY_REPAIRING_CARS: (state) => {
    const repairedCars = state.carParkData.filter(xu => xu.status === 'repairing')
    return [...new Set(repairedCars)]
  },
  GET_ONLY_NUMBERS: (state) => {
    const onlyNumbers = state.carParkData.map(a => a.number)
    return [...new Set(onlyNumbers)]
  },
  GET_ONLY_YEARS: (state) => {
    const onlyYears = state.carParkData.map(a => a.year)
    return [...new Set(onlyYears)]
  },
  GET_ONLY_CALLSIGN: (state) => {
    const onlyCallsign = state.carParkData.map(a => a.callsign)
    return [...new Set(onlyCallsign)]
  },
  GET_CAR_BY_ID: (state) => prop_id => {
    return state.carParkData.filter(item => item.carId === prop_id)[0]
  },
  GREAT_NAME_BY_ID: (state) => prop_id => {
    if (!prop_id) return 'Выберете автомобиль'
    return state.carParkData.filter(item => item.carId === prop_id).map(car => `${car.brand} ${car.model} — ${car.number} — ${car.callsign}`)[0]
  },
  sortedDataByFilter: (state) => {
    return state.carParkData
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
